import React from "react";
import "./QuestionPopup.css";
import { convertSnakeCaseInText } from "../../../utils/helpers";

const QuestionPopup = ({ question, onClose, onSubmit }) => {
  const handleSubmit = () => {
    // No answer input, just save button
    onSubmit();
  };
  const handleClose = () => {
    onClose();
  };

  if (!question) return null;

  return (
    <div className="question-overlay">
      <div className="question-modal">
        <h3>Quick Check</h3>
        <p className="question-text">{question.text}</p>
        <p className="question-category">{convertSnakeCaseInText(question.category)}</p>
        <div className="d-flex gap-2 justify-content-end">
        <div className="question-actions">
          <button className="btn-skip" onClick={handleClose}>
            Skip
          </button>
        </div>
        <div className="question-actions">
          <button className="btn-submit" onClick={handleSubmit}>
            Save
          </button>
        </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionPopup;